export const CONNECT_BUTTON_LABEL_SIGN_IN = 'Connect Trace Data';

/** Shown when connected (compact header); opens switch-org flow without signing out yet. */
export const SWITCH_ORGANISATION_BUTTON_LABEL = 'Switch organisation';

/** Shown in switch-org flow after the user chose a new org code; proceeds to sign-in (current session ends first). */
export const CONTINUE_SWITCH_ORGANISATION_BUTTON_LABEL = 'Continue';

/** Set to `false` to silence `[trace-excel-addin auth]` console logs in production builds. */
export const TRACE_ADDIN_DEBUG_AUTH = true;

/** If true, Office on the web skips the built‑in “allow this window?” step before opening the dialog. */
export const SKIP_OFFICE_DIALOG_ALLOW_PROMPT = true;

/** Usermanagerauth provider-info endpoint (Keycloak via `provider=2`). */
export const AUTH_PROVIDER_INFO_URL = `${__TRACE_ADDIN_AUTH_API_ORIGIN__}/usermanagerauth/api/v1/auth/provider/info`;

/** `sessionStorage` key for the last org code used for a successful connect (optional convenience). */
export const TRACE_ADDIN_LAST_ORG_CODE_STORAGE_KEY = 'trace-reports-excel-addin-last-org-code';

/** Placeholder URLs until production legal pages are published. */
export const TRACE_ADDIN_TERMS_OF_USE_URL = 'https://example.com/terms';
export const TRACE_ADDIN_PRIVACY_POLICY_URL = 'https://example.com/privacy';

/**
 * Builds the URL opened in the Office auth dialog; `orgCode` must be non-empty (trimmed).
 * Always `platform=localhost_https` (see `webpack.trace-addin-deploy.config.js` → `DefinePlugin`).
 * Usermanager uses **`KeycloakLocalhostHttps:RedirectURL`** for the post–Keycloak redirect (local vs hosted URL is config only).
 */
export function buildAuthProviderInfoUrl(orgCode: string): string {
    const trimmed = orgCode.trim();
    const q = [
        `orgCode=${encodeURIComponent(trimmed)}`,
        'provider=2',
        `platform=${encodeURIComponent(__TRACE_ADDIN_AUTH_PROVIDER_INFO_PLATFORM__)}`,
    ].join('&');
    return `${AUTH_PROVIDER_INFO_URL}?${q}`;
}

export const MAX_CELLS_TO_SCAN_FOR_CONTENT = 20_000;

/** Must match `<option value="...">` for Agreements in `taskpane.html` and `agreementsReportingTargetDefinition.targetId`. */
export const REPORT_TARGET_AGREEMENTS_VALUE = 'agreements';

/** Must match `<option value="...">` for Material Summary in `taskpane.html` and `materialSummaryReportingTargetDefinition.targetId`. */
export const REPORT_TARGET_MATERIAL_SUMMARY_VALUE = 'material-summary';
